import styled from "styled-components";

import xIcon from "../../../../assets/Mayo/DoNot.svg"
import vIcon from "../../../../assets/Mayo/Do.svg"

function FastingInstruction({Icon: icon, instructions}) {
  return(
    <SubContainer>
      <Icon
        src={icon}
      />
      <div>
        {instructions && 
          instructions.map((instruction, i) => 
            <Instruction
          key={`gi${i}`}
          >
              {instruction}
            </Instruction>
          )
        }
      </div>
    </SubContainer>
  );
}

export default function FastingInstructions({title, eat, dontEat, instructions, noHL = false}) {
  const titleStyle = noHL ? {marginBottom: 8} : {};

  return (
    <Container>
      <Title style={titleStyle}>
        {title}
      </Title>
      
      { !noHL &&
        <HL/>
      }

      {instructions && 
        instructions.map((instruction, i) => 
          <Instruction
            key={`gi${i}`}
          >
            {instruction}
          </Instruction>
        )
      }

      <FlexBox>
        {dontEat &&
          <FastingInstruction
            Icon={xIcon}
            instructions={dontEat}
          />
        }

        {eat &&
          <FastingInstruction
            Icon={vIcon}
            instructions={eat}
          />
        }
      </FlexBox>
      
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;

`

const FlexBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Icon = styled.img`
  height: 32px;
  width: 28px;
`

const Title = styled.p`
  color: #82A4FC;
  font-family: Abraham, Bold;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
`

const Instruction = styled.p`
  font-family: Abraham, Regular;
  font-size: 19px;
  color: #1A1A1A;
  font-weight: 400;
  margin-block: 0;
`

const HL = styled.div`
  height: 1px;
  background-color: #CCD9FB;
  margin-top: 9px;
  margin-bottom: 20px;
`